export enum CustomerStatus {
  Active = "A",
  Inactive = "I",
  WaitingForEmailConfirmation = "W",
}
